/* ═════════════════════════════════════
   VISA PAGE
═════════════════════════════════════ */

export const SERVICE_CHARGE = 1500; // INR per application

export const VISA_DATA = [
  /* ─── Asia Pacific ───────────────────────── */
  {
    country: 'Thailand', region: 'Asia Pacific', flag: 'TH',
    type: 'Visa on Arrival', currency: 'THB', fee: 2000, feeINR: 4800,
    processing: '1–2 Days', validity: '30 Days', entries: 'Single',
    docs: ['Passport (6 months validity)', 'Return ticket', 'Hotel booking', 'Passport photo'],
    popular: true, color: '#0ea5e9',
  },
  {
    country: 'Bali (Indonesia)', region: 'Asia Pacific', flag: 'ID',
    type: 'Visa on Arrival', currency: 'USD', fee: 35, feeINR: 2900,
    processing: '1 Day', validity: '30 Days', entries: 'Single',
    docs: ['Passport (6 months validity)', 'Return ticket', 'Sufficient funds proof'],
    popular: true, color: '#f97316',
  },
  {
    country: 'Singapore', region: 'Asia Pacific', flag: 'SG',
    type: 'e-Visa', currency: 'SGD', fee: 30, feeINR: 1850,
    processing: '3–5 Working Days', validity: '30 Days', entries: 'Single/Multiple',
    docs: ['Passport copy', 'Bank statement', '3 months', 'Photograph', 'ITR / Pay slips'],
    popular: true, color: '#8b5cf6',
  },
  {
    country: 'Malaysia', region: 'Asia Pacific', flag: 'MY',
    type: 'eNTRI / eVisa', currency: 'MYR', fee: 0, feeINR: 0,
    processing: 'Instant', validity: '15 Days', entries: 'Single',
    docs: ['Passport (6 months validity)', 'Return ticket', 'Hotel booking'],
    popular: true, color: '#10b981',
  },
  {
    country: 'Vietnam', region: 'Asia Pacific', flag: 'VN',
    type: 'e-Visa', currency: 'USD', fee: 25, feeINR: 2100,
    processing: '3 Working Days', validity: '90 Days', entries: 'Multiple',
    docs: ['Passport scan', 'Passport photo', 'Credit/Debit card'],
    popular: true, color: '#ef4444',
  },
  {
    country: 'Sri Lanka', region: 'Asia Pacific', flag: 'LK',
    type: 'e-Visa', currency: 'USD', fee: 20, feeINR: 1680,
    processing: '2–3 Days', validity: '30 Days', entries: 'Double',
    docs: ['Passport scan', 'Photograph', 'Hotel booking', 'Return ticket'],
    popular: false, color: '#d97706',
  },
  {
    country: 'Japan', region: 'Asia Pacific', flag: 'JP',
    type: 'Sticker Visa', currency: 'JPY', fee: 3000, feeINR: 1680,
    processing: '5–7 Working Days', validity: '90 Days', entries: 'Single/Multiple',
    docs: ['6 months bank statement', 'Employment letter', 'ITR', 'Hotel + Itinerary', 'Photograph'],
    popular: true, color: '#e11d48',
  },
  {
    country: 'Maldives', region: 'Asia Pacific', flag: 'MV',
    type: 'Free on Arrival', currency: 'USD', fee: 0, feeINR: 0,
    processing: 'Immediate', validity: '30 Days', entries: 'Single',
    docs: ['Passport (6 months validity)', 'Return ticket', 'Hotel + Resort booking'],
    popular: true, color: '#0ea5e9',
  },
  {
    country: 'Philippines', region: 'Asia Pacific', flag: 'PH',
    type: 'Visa on Arrival', currency: 'USD', fee: 0, feeINR: 0,
    processing: 'Immediate', validity: '30 Days', entries: 'Single',
    docs: ['Passport (6 months validity)', 'Return ticket', 'Sufficient funds'],
    popular: false, color: '#2563eb',
  },
  {
    country: 'Hong Kong', region: 'Asia Pacific', flag: 'HK',
    type: 'Visa on Arrival', currency: 'HKD', fee: 0, feeINR: 0,
    processing: 'Immediate', validity: '14 Days', entries: 'Single',
    docs: ['Passport (6 months validity)', 'Return ticket', 'Hotel booking'],
    popular: false, color: '#7c3aed',
  },

  /* ─── Middle East ────────────────────────── */
  {
    country: 'UAE / Dubai', region: 'Middle East', flag: 'AE',
    type: 'e-Visa', currency: 'AED', fee: 350, feeINR: 8000,
    processing: '3–5 Working Days', validity: '30/60 Days', entries: 'Single/Multiple',
    docs: ['Passport (6 months validity)', 'Photograph', 'Bank statement', 'Confirmed ticket'],
    popular: true, color: '#d4a437',
  },
  {
    country: 'Oman', region: 'Middle East', flag: 'OM',
    type: 'e-Visa', currency: 'OMR', fee: 20, feeINR: 4350,
    processing: '3–5 Days', validity: '30 Days', entries: 'Single',
    docs: ['Passport scan', 'Photograph', 'Bank statement', 'Flight itinerary'],
    popular: false, color: '#16a34a',
  },
  {
    country: 'Saudi Arabia', region: 'Middle East', flag: 'SA',
    type: 'e-Visa', currency: 'SAR', fee: 300, feeINR: 6700,
    processing: '24–72 Hours', validity: '1 Year', entries: 'Multiple',
    docs: ['Passport (6 months validity)', 'Photograph', 'Credit card for payment'],
    popular: false, color: '#15803d',
  },
  {
    country: 'Azerbaijan', region: 'Middle East', flag: 'AZ',
    type: 'e-Visa', currency: 'USD', fee: 20, feeINR: 1680,
    processing: '3 Working Days', validity: '30 Days', entries: 'Single',
    docs: ['Passport scan', 'Photograph', 'Return ticket'],
    popular: false, color: '#0284c7',
  },

  /* ─── Europe ─────────────────────────────── */
  {
    country: 'Switzerland', region: 'Europe', flag: 'CH',
    type: 'Schengen Visa', currency: 'EUR', fee: 85, feeINR: 7700,
    processing: '10–15 Working Days', validity: '90 Days', entries: 'Single/Multiple',
    docs: ['6 months bank statement', 'Employment letter', 'ITR 3 years', 'Travel insurance', 'Hotel + Itinerary', 'Photograph'],
    popular: true, color: '#dc2626',
  },
  {
    country: 'France', region: 'Europe', flag: 'FR',
    type: 'Schengen Visa', currency: 'EUR', fee: 85, feeINR: 7700,
    processing: '10–15 Working Days', validity: '90 Days', entries: 'Single/Multiple',
    docs: ['Bank statement', 'Employment proof', 'ITR', 'Flight + Hotel booking', 'Travel insurance'],
    popular: true, color: '#1d4ed8',
  },
  {
    country: 'Italy', region: 'Europe', flag: 'IT',
    type: 'Schengen Visa', currency: 'EUR', fee: 85, feeINR: 7700,
    processing: '10–15 Working Days', validity: '90 Days', entries: 'Single/Multiple',
    docs: ['Bank statement', 'Employment proof', 'ITR', 'Flight + Hotel booking', 'Travel insurance'],
    popular: true, color: '#16a34a',
  },
  {
    country: 'UK', region: 'Europe', flag: 'GB',
    type: 'Standard Visitor Visa', currency: 'GBP', fee: 115, feeINR: 12000,
    processing: '15–21 Working Days', validity: '6 Months', entries: 'Multiple',
    docs: ['6 months bank statement', 'Employment letter', 'Property ownership', 'ITR', 'Cover letter', 'Photograph'],
    popular: true, color: '#1e40af',
  },
  {
    country: 'Greece', region: 'Europe', flag: 'GR',
    type: 'Schengen Visa', currency: 'EUR', fee: 85, feeINR: 7700,
    processing: '10–15 Working Days', validity: '90 Days', entries: 'Single/Multiple',
    docs: ['Bank statement', 'Employment proof', 'ITR', 'Hotel + Itinerary', 'Insurance'],
    popular: true, color: '#0284c7',
  },
  {
    country: 'Turkey', region: 'Europe', flag: 'TR',
    type: 'e-Visa', currency: 'USD', fee: 65, feeINR: 5460,
    processing: '1–3 Working Days', validity: '90 Days', entries: 'Multiple',
    docs: ['Passport scan', 'Credit/Debit card'],
    popular: true, color: '#dc2626',
  },

  /* ─── Africa ─────────────────────────────── */
  {
    country: 'Mauritius', region: 'Africa', flag: 'MU',
    type: 'Free on Arrival', currency: 'USD', fee: 0, feeINR: 0,
    processing: 'Immediate', validity: '90 Days', entries: 'Single',
    docs: ['Passport (6 months validity)', 'Return ticket', 'Hotel booking', 'Sufficient funds'],
    popular: true, color: '#7c3aed',
  },
  {
    country: 'Kenya', region: 'Africa', flag: 'KE',
    type: 'e-Visa', currency: 'USD', fee: 50, feeINR: 4200,
    processing: '3–5 Days', validity: '90 Days', entries: 'Single',
    docs: ['Passport scan', 'Photograph', 'Bank statement', 'Yellow fever certificate'],
    popular: false, color: '#15803d',
  },
  {
    country: 'South Africa', region: 'Africa', flag: 'ZA',
    type: 'Sticker Visa', currency: 'ZAR', fee: 1520, feeINR: 6700,
    processing: '10–15 Working Days', validity: '90 Days', entries: 'Single',
    docs: ['Bank statement', 'Employment letter', 'Photograph', 'Itinerary', 'Yellow fever certificate'],
    popular: false, color: '#d97706',
  },

  /* ─── Americas ───────────────────────────── */
  {
    country: 'USA', region: 'Americas', flag: 'US',
    type: 'B1/B2 Visa', currency: 'USD', fee: 185, feeINR: 15540,
    processing: '30–90 Days (Interview)', validity: '10 Years', entries: 'Multiple',
    docs: ['DS-160 form', 'Bank statement', 'Employment proof', 'Property docs', 'ITR', 'Interview appointment'],
    popular: true, color: '#1e40af',
  },
  {
    country: 'Canada', region: 'Americas', flag: 'CA',
    type: 'TRV (Sticker Visa)', currency: 'CAD', fee: 100, feeINR: 6200,
    processing: '15–30 Working Days', validity: '10 Years', entries: 'Multiple',
    docs: ['Bank statement', 'Employment proof', 'IELTS (if required)', 'Itinerary', 'Photograph', 'Biometrics'],
    popular: true, color: '#dc2626',
  },
];

/* Service charge breakdown */
export const SERVICE_BREAKDOWN = [
  { label: 'Documentation Review',      charge: 500 },
  { label: 'Form Filling & Submission', charge: 300 },
  { label: 'Embassy Appointment',       charge: 400 },
  { label: 'Status Tracking',           charge: 300 },
];

/* Group by region helper */
export const getRegions = () => [...new Set(VISA_DATA.map(v => v.region))];
export const byRegion   = (region) => VISA_DATA.filter(v => v.region === region);
